import React from "react";
import { string, oneOf } from "prop-types";

import "./heading.m.css";

const Heading = ({ children, variant = "desktop", level = "h1", ...props }) => {
  const Tag = level;
  const styleClass = variant === "mobile" ? "heading-mobile" : "heading-desktop";

  return (
    <Tag styleName={styleClass} {...props}>
      {children}
    </Tag>
  );
};

Heading.propTypes = {
  children: string.isRequired,
  variant: oneOf(["desktop", "mobile"]),
  level: oneOf(["h1", "h2", "h3", "h4", "h5", "h6"])
};

export default Heading;